import global$1 from '../internals/global.js';
import descriptors from '../internals/descriptors.js';
import regexpStickyHelpers from '../internals/regexp-sticky-helpers.js';
import classofRaw from '../internals/classof-raw.js';
import '../internals/object-define-property.js';
import internalState from '../internals/internal-state.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var global = global$1;
var DESCRIPTORS = descriptors;
var MISSED_STICKY = regexpStickyHelpers.MISSED_STICKY;
var classof = classofRaw;
var defineProperty = objectDefineProperty.f;
var getInternalState = internalState.get;
var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError; // `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky

if (DESCRIPTORS && MISSED_STICKY) {
  defineProperty(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined; // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.

      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }

      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}
